import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import './index.css';
import './i18n';
import App from './App';
import { installAuthInterceptor } from './api/client';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { denyUrls, ignoreErrors } from './sentryFilters';

Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.NODE_ENV || 'development',
    release: process.env.REACT_APP_RELEASE || 'unknown',
    enabled: !!process.env.REACT_APP_SENTRY_DSN,
    sendDefaultPii: true,
    initialScope: {
        // Distinguishes frontend errors from backend in the shared `linked-coffee` project.
        // Filter in Sentry with: tag:service:frontend
        tags: { service: 'frontend' },
    },
    // Чужой шум (Usercentrics, расширения браузера) — см. sentryFilters.js
    denyUrls,
    ignoreErrors,
});

// Before anything renders: every authenticated fetch goes through the 401/renewal check.
installAuthInterceptor();

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
        <React.StrictMode>
            <App />
        </React.StrictMode>
    </GoogleOAuthProvider>
);
